import { makeStyles } from "@material-ui/core/styles";


const useStyles = makeStyles((theme) => ({
  "@global": {
    ul: {
      margin: 0,
      padding: 0,
      listStyle: "none",
    },
  },

  pageGlobal: { display: "flex", flexDirection: "column", minHeight: "100vh" },
  appBar: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  toolbar: {
    flexWrap: "wrap",
  },
  toolbarTitle: {
    flexGrow: 1,
    marginLeft: "2rem",
  },
  toolbarTitleImage: {
    width: "auto",
    height: "3rem",
    margin: "1rem",
    filter: "invert(1)",
  },
  notificationCheck:{
    marginTop: theme.spacing(2),
  },
  link: {
    margin: theme.spacing(1, 1.5),
    color: "white",
  },
  icon: {
    marginRight: theme.spacing(2),
  },
  chip: {
    color: theme.palette.primary.main,
    maxHeight:theme.spacing(1),
    width:theme.spacing(7),
  },
  containerFuid:{
    // marginRight:theme.spacing(20),
    // marginLeft:theme.spacing(20),
    // width:"",
  },
  mainContent: {
    // marginTop: theme.spacing(5),
    marginBottom: theme.spacing(3),
  },
  heroContent: {
    padding: theme.spacing(3, 0, 3),
  },
  heroButtons: {
    marginTop: theme.spacing(3),
  },
  cardGrid: {
    paddingLeft: theme.spacing(10),
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(8),
  },
  card: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  cardMedia: {
    paddingTop: "56.25%", // 16:9
  },
  cardContent: {
    flexGrow: 1,
  },
  dobDatePicker: {
    margin: 0,
  },
  footer: {
    marginTop: "auto",
    backgroundColor: theme.palette.primary.main,
    color: "white",
    padding: theme.spacing(2),
    "& .footerLogo": { filter: "invert(1)" },
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: "inherit",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  sroot: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    width: "inherit",
  },
  input: {
    marginLeft: theme.spacing(11),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  createButton: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(1.5),
  },
}));
export default useStyles